import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'
import { Typography, Box, CircularProgress, Grid } from '@mui/material'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'

import { useUserContext } from '../../../../core/user' // CORRECCIÓN: Vuelto a 'useUserContext'
import { useAjaxContext } from '../../../../core/ajax'
import { feedback } from '../../../../core/feedback'
import { resetUserData, selectUser } from '../../slices'
import { verifyPwd } from '../../../../core/utils/pwdUtils'
import { logoutUser } from '../../../global'
import { resetAppsData } from '../../../applications/slices'
import { ThemeButton, GridRow, PasswordInput } from '../../../../ui'
import { USER_GRID_ROW_ITEMS } from '../../constants'

export const ProfileUserComponent = () => {
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()
  const { userDispatch } = useUserContext() // CORRECCIÓN: Vuelto a 'useUserContext'
  const user = useSelector(selectUser)
  const isLoading = useSelector((state) => state.profile.isLoading)
  const { put } = useAjaxContext()

  const [formState, setFormState] = useState({})
  const [loading, setLoading] = useState(false)
  const [errorMssg, setErrorMssg] = useState('')
  const [isValidPassword, setIsValidPassword] = useState(false)

  const handleLogout = () => {
    dispatch(resetAppsData())
    dispatch(logoutUser(userDispatch))
    dispatch(resetUserData())
  }

  useEffect(() => {
    verifyPwd(
      formState['newPassword'],
      formState['repitNewPassword'],
      isValidPassword,
      setIsValidPassword,
      setErrorMssg
    )
  }, [formState])

  const handleChangeForm = (event) =>
    setFormState({ ...formState, [event.target.name]: event.target.value })

  const handleSubmitForm = (event) => {
    event.preventDefault()
    setErrorMssg('')
    setLoading(true)
    if (isValidPassword) {
      const payload = {
        password: formState['currentPassword'],
        new_password: formState['newPassword'],
      }
      put('/usuario/modify_password', payload)
        .then(() => {
          setLoading(false)
          feedback('success', formatMessage({ id: 'pages.profile.pwd.feedback.1' }))
        })
        .catch((response) => {
          setLoading(false)
          const errorMssg =
            response?.response?.data?.message ||
            formatMessage({ id: 'pages.profile.pwd.feedback.2' })
          feedback('error', errorMssg)
        })
    }
  }

  return isLoading ? (
    <Box display="flex" height={100} justifyContent="center" alignItems="center">
      <CircularProgress size={40} />
    </Box>
  ) : (
    <Box mb={3}>
      <Box display="flex" mb={1} flexWrap="wrap">
        <Box display="flex" alignItems="center" flexGrow={4} mr={2}>
          <AccountCircleOutlinedIcon sx={{ width: 45, height: 45, mr: '10px' }} />
          <Typography variant="h4" color="primary">
            {(user['nombre'] || '') + ' ' + (user['apellidos'] || '')}
          </Typography>
        </Box>
        <Box display="flex">
          <ThemeButton variant="contained" color="inherit" onClick={handleLogout}>
            {formatMessage({ id: 'pages.profile.header.button2' })}
          </ThemeButton>
        </Box>
      </Box>
      <Box bgcolor="common.white" borderRadius="6px" p={3}>
        <Typography variant="h6" color="primary" component={'h6'}>
          {formatMessage({ id: 'pages.profile.user.title' })}:
        </Typography>
        <GridRow items={USER_GRID_ROW_ITEMS} data={user} justify="flex-start" spacing={8} />
      </Box>
      <Box bgcolor="common.white" borderRadius="6px" p={3}>
        <form onSubmit={handleSubmitForm}>
          <Box mb={3}>
            <Typography variant="h6" color="primary" paragraph>
              {formatMessage({ id: 'pages.profile.pwd.subtitle' })}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
              {formatMessage({ id: 'pages.profile.pwd.description' })}
            </Typography>
          </Box>

          <Box mb={4}>
            <Box display="flex" flexDirection="column" gap={3}>
              <Box display="flex" gap={3}>
                <Box sx={{ width: '50%' }}>
                  <PasswordInput
                    value={formState['currentPassword']}
                    name="currentPassword"
                    title={formatMessage({ id: 'pages.profile.pwd.fields.currentPwd' })}
                    placeholder={formatMessage({ id: 'pages.profile.pwd.fields.currentPwd' })}
                    onChange={handleChangeForm}
                    required
                  />
                </Box>
                <Box sx={{ width: '50%' }}>
                  <PasswordInput
                    value={formState['newPassword']}
                    name="newPassword"
                    title={formatMessage({ id: 'pages.profile.pwd.fields.newPwd' })}
                    placeholder={formatMessage({ id: 'pages.profile.pwd.fields.newPwd' })}
                    onChange={handleChangeForm}
                    required
                  />
                </Box>
              </Box>
              <Box sx={{ width: '48.5%' }}>
                <PasswordInput
                  value={formState['repitNewPassword']}
                  name="repitNewPassword"
                  title={formatMessage({ id: 'pages.profile.pwd.fields.repitPwd' })}
                  placeholder={formatMessage({ id: 'pages.profile.pwd.fields.repitPwd' })}
                  onChange={handleChangeForm}
                  required
                />
              </Box>
            </Box>
          </Box>

          {errorMssg && (
            <Box mb={1}>
              <Typography variant="body2" color="error">
                {errorMssg}
              </Typography>
            </Box>
          )}
          <Box display="flex" justifyContent="center">
            <ThemeButton type="submit" loading={loading} disabled={!isValidPassword}>
              {formatMessage({ id: 'pages.profile.pwd.button.save' })}
            </ThemeButton>
          </Box>
        </form>
      </Box>
    </Box>
  )
}
